import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import i18n from "../../i18n";
import { GeneralImage } from "../../components";

type NotificationToastProps = {
  show: boolean;
  onClose?: () => void;
  duration?: number;
  item?: any;
};

const NotificationToast: React.FC<NotificationToastProps> = ({
  show,
  onClose,
  duration = 6000,
  item,
}) => {
  const [visible, setVisible] = useState(show);

  const navigate = useNavigate();
  const currentLanguage = i18n.language?.slice(0, 2);

  const data = {
    Title: currentLanguage == "en" ? item?.titleEn : item?.titleAr,
    Description:
      currentLanguage == "en" ? item?.descriptionEn : item?.descriptionAr,
    Image: item?.image,
  };

  useEffect(() => {
    setVisible(show);
    if (show && duration) {
      const timer = setTimeout(() => {
        onClose?.();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [show, duration, onClose]);

  return (
    <div
      onClick={() => {
        onClose?.();
        let route =
          item.type === "APPOINTMENT"
            ? `/appointments/${item?.itemId}`
            : item.type === "DOCUMENT"
              ? "/profile/doctor_specialty"
              : undefined;

        !!route && navigate(route);
      }}
      className={`fixed bottom-12 end-10 z-50 w-full max-w-md cursor-pointer rounded-lg border bg-systemBg p-4 opacity-90 shadow-2xl transition-all duration-300 ${
        visible
          ? "translate-y-0 opacity-100"
          : "pointer-events-none translate-y-4 opacity-0"
      }`}
      style={{ backdropFilter: "blur(16px)" }}
    >
      {data?.Image && (
        <GeneralImage
          src={data.Image}
          alt="notification"
          className="h-12 w-12 rounded-md bg-white/30 object-contain"
        />
      )}
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <div className="text-primary-text font-semibold">{data?.Title}</div>
          <div className="text-primary-text mt-2">{data?.Description}</div>
        </div>

        {onClose && (
          <button
            onClick={(event) => {
              event.stopPropagation();
              onClose();
            }}
            className="text-xl font-bold text-gray-600 hover:opacity-60"
          >
            ×
          </button>
        )}
      </div>
    </div>
  );
};
export default NotificationToast;
